(function () {
  'use strict';

  function isValidEmail(email) {
    return /^[a-z0-9.]+@[a-z0-9]+\.[a-z]+(\.([a-z]+))?$/i.test(email);
  }

  function isValidPhone(phone) {
    return /^\+55 \(\d{2}\) \d{5}-\d{4}$/.test(phone);
  }

  /**
   * Debounce function.
   *
   * @param {Function} func Function fot to peforme.
   * @param {Number} timeout Timeout in milisseconds
   * @returns {Null}
   */
  function debounce(func, timeout = 300) {
    let timer;

    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }

  if (!window.customElements.get('insider-form')) {
    window.customElements.define(
      'insider-form',
      class extends HTMLElement {
        constructor() {
          super();
          this.onSubmitListener = this._onSubmit.bind(this);
          this.onKeyupListener = debounce(this._onKeyup.bind(this));
          this.onKeyupPhoneListener = this._onKeyupPhone.bind(this);
        }

        connectedCallback() {
          this.querySelector('.insider-form__button').addEventListener('click', this.onSubmitListener);
          this.querySelector('[name="phone_number"]').addEventListener('input', this.onKeyupPhoneListener);
          this.querySelectorAll('.insider-form__input').forEach((input) => {
            input.addEventListener('keyup', this.onKeyupListener);
          });
        }

        disconnectedCallback() {
          this.querySelector('.insider-form__button').removeEventListener('click', this.onSubmitListener);
          this.querySelector('[name="phone_number"]').removeEventListener('input', this.onKeyupPhoneListener);
          this.querySelectorAll('.insider-form__input').forEach((input) => {
            input.removeEventListener('keyup', this.onKeyupListener);
          });
        }

        _onKeyupPhone(e) {
          var x = e.target.value
            .replace('+55', '')
            .replace(/\D/g, '')
            .match(/(\d{0,2})(\d{0,5})(\d{0,4})/);
          e.target.value = !x[1] ? x[0] : '+55 (' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
        }

        _onSubmit(e) {
          e.preventDefault();

          const button = e.currentTarget;
          const buttonLabel = button.innerText;
          const listID = this.getAttribute('list-id');

          button.disabled = true;
          button.innerText = 'Enviando...';

          window.insider_object = window.insider_object || {};

          window.insider_object.user = {
            name: this.querySelector('[name="fullname"]').value,
            email: this.querySelector('[name="email"]').value,
            phone_number: '+' + this.querySelector('[name="phone_number"]').value.replace(/[^0-9]/g, ''),
            language: 'pt-br',
            gdpr_optin: true,
            email_optin: true,
            list_id: [listID],
          };

          Insider.eventManager.dispatch('init-manager:re-initialize');

          setTimeout(() => {
            this.querySelector('.insider-form__message').classList.add('active');
            this.querySelector('.insider-form__wrapper').classList.add('hide');

            button.disabled = false;
            button.innerText = buttonLabel;
          }, 750);
        }

        _onKeyup(e) {
          e.preventDefault();

          let lockedButton = true;

          this.querySelectorAll('.insider-form__input').forEach((input) => {
            switch (input.name) {
              case 'first_name':
                lockedButton = input.name.length > 3;
                break;

              case 'email':
                lockedButton = isValidEmail(input.value);
                break;

              case 'phone':
                lockedButton = isValidPhone(input.value);
                break;
            }
          });

          this.querySelector('.insider-form__button').disabled = !lockedButton;
        }
      }
    );
  }

  if (!window.customElements.get('quantity-free-shipping')) {
    window.customElements.define(
      'quantity-free-shipping',
      class extends HTMLElement {
        constructor() {
          super();

          this.onChangeListener = this._onChange.bind(this);
          this.maxItems = this.getAttribute('max-items');
          this.progressBar = this.querySelector('.quantity-free-shipping__progress-bar');

          fetch('/cart.js')
            .then((r) => r.json())
            .then((cart) => {
              this._onChange({
                detail: {
                  cart,
                },
              });
            });
        }
        connectedCallback() {
          document.addEventListener('cart:refresh', this.onChangeListener);
        }
        _onChange(e) {
          try {
            const cart = e.detail.cart;
            const cartItemCount =
              cart.item_count -
              cart.items.reduce(function (acum, item) {
                if (item.discounted_price === 0) {
                  acum += item.quantity;
                }

                return acum;
              }, 0);
            const progress = Math.min((cartItemCount / this.maxItems).toFixed(2), 1);

            this.progressBar.style.setProperty('--progress', progress);

            this._updateMessage.call(this, cart);
          } catch (err) {
            console.error('[Free Shipping Error]', err);
          }
        }
        _updateMessage(cart) {
          let message = '';
          const cartItemCount =
            cart.item_count -
            cart.items.reduce(function (acum, item) {
              if (item.discounted_price === 0) {
                acum += item.quantity;
              }

              return acum;
            }, 0);

          this.querySelectorAll('.quantity-free-shipping__step').forEach((step) => {
            if (cartItemCount >= step.dataset.value) {
              step.classList.add('reached');
              message = step.dataset.message;
            } else {
              step.classList.remove('reached');
            }
          });

          if (message.length > 0) {
            this.querySelector('.quantity-free-shipping__message').innerHTML = message;
          }
        }
      }
    );
  }

  if (!window.customElements.get('checkbox-upsell')) {
    window.customElements.define(
      'checkbox-upsell',
      class extends HTMLElement {
        constructor() {
          super();

          this.onChangeListener = this._onChange.bind(this);
        }
        connectedCallback() {
          this.querySelector('[type="checkbox"]').addEventListener('change', this.onChangeListener);
        }
        async _onChange(e) {
          e.preventDefault();

          this.checkbox = this.querySelector('[type="checkbox"]');

          try {
            if (this.checkbox.checked == true) {
              await fetch(Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                body: JSON.stringify({
                  id: this.checkbox.value,
                  quantity: 1,
                  properties: {
                    _origin: 'upsell',
                  },
                }),
                headers: {
                  'Content-Type': 'application/json',
                },
              });

              document.dispatchEvent(new CustomEvent('variant:add'));
            } else {
              await fetch(Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                body: JSON.stringify({
                  id: this.checkbox.value,
                  quantity: 0,
                }),
                headers: {
                  'Content-Type': 'application/json',
                },
              });

              document.dispatchEvent(new CustomEvent('cart:refresh'));
            }

            if (window.location.pathname === '/cart') {
              window.history.reload();
            }
          } catch (err) {
            console.error(err);
          }
        }
      }
    );
  }

  class MobileNavigation extends HTMLElement {
    constructor() {
      super();

      this.closeMobileMenu = this.querySelector('.mobile-navigation__button-close');
      this.menuButton = Array.from(document.querySelectorAll('[aria-controls="menu-mobile"]'));
      this.superLinks = Array.from(
        this.querySelectorAll('.mobile-navigation__menu-item--has-child > .mobile-navigation__item-link')
      );
      this.menuBlockTitle = Array.from(
        this.querySelectorAll('.mobile-navigation__menu-block > .mobile-navigation__item-title')
      );
      this.menuButtonListener = this._menuButton.bind(this);
      this.openSubmenuListener = this._openSubmenu.bind(this);
      this.closeMenuBlockListener = this._closeMenuBlock.bind(this);
      this.closeMobileMenuListener = this._closeMobileMenu.bind(this);
    }
    connectedCallback() {
      this.addEventListener('click', (e) => {
        if (e.target.classList.contains('mobile-navigation')) {
          this._closeMobileMenu();
        }
      });
      document.addEventListener('keyup', (e) => {
        if (e.code === 'Escape') {
          this._closeMobileMenu();
        }
      });
      this.closeMobileMenu.addEventListener('click', this.closeMobileMenuListener);
      this.menuButton.forEach((button) => {
        button.addEventListener('click', this.menuButtonListener);
      });
      this.superLinks.forEach((link) => {
        link.addEventListener('click', this.openSubmenuListener);
      });
      this.menuBlockTitle.forEach((title) => {
        title.addEventListener('click', this.closeMenuBlockListener);
      });
    }
    disconnectedCallback() {
      this.removeEventListener('click', (e) => {
        if (e.target.classList.contains('mobile-navigation')) {
          this._closeMobileMenu();
        }
      });
      document.removeEventListener('keyup', (e) => {
        if (e.code === 'Escape') {
          this._closeMobileMenu();
        }
      });
      this.closeMobileMenu.removeEventListener('click', this.closeMobileMenuListener);
      this.menuButton.forEach((button) => {
        button.removeEventListener('click', this.menuButtonListener);
      });
      this.superLinks.forEach((link) => {
        link.removeEventListener('click', this.openSubmenuListener);
      });
      this.menuBlockTitle.forEach((title) => {
        title.removeEventListener('click', this.closeMenuBlockListener);
      });
    }
    _menuButton() {
      this.classList.add('active');
    }
    _closeMobileMenu() {
      this.classList.remove('active');

      setTimeout(() => {
        this.querySelectorAll('.active').forEach((el) => {
          el.classList.remove('active');
        });
      }, 300);
    }
    _openSubmenu(e) {
      e.preventDefault();

      const menuItem = e.currentTarget.parentNode;
      const menuBlock = e.currentTarget.closest('.mobile-navigation__menu-block');

      if (menuBlock && menuItem) {
        menuItem.classList.add('active');
        menuBlock.classList.add('active');
      }
    }
    _closeMenuBlock(e) {
      e.preventDefault();

      const menuItem = e.currentTarget.closest('.mobile-navigation__menu-item');
      const menuBlock = e.currentTarget.closest('.mobile-navigation__menu-block.active');

      if (menuBlock && menuItem) {
        menuItem.classList.remove('active');
        menuBlock.classList.remove('active');
      }
    }
  }
  if (!window.customElements.get('mobile-navigation')) {
    window.customElements.define('mobile-navigation', MobileNavigation);
  }

  class HeaderSearch extends HTMLElement {
    constructor() {
      super();

      this.suggestions = this.querySelector('#search-results').innerHTML;
      this.input = this.querySelector('[name="q"]');
      this.typingListener = this._typing.bind(this);
      this.focusListener = this._focus.bind(this);
      this.buttonClose = this.querySelector('.header-search__button--close');
      this.closeSearchListener = this._closeSearch.bind(this);
    }
    connectedCallback() {
      this.input.addEventListener('input', debounce(this.typingListener));
      this.input.addEventListener('focus', this.focusListener);
      this.buttonClose.addEventListener('click', this.closeSearchListener);
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.header-search')) {
          this._closeSearch(e);
        }
      });
      document.addEventListener('keyup', (e) => {
        if (e.code === 'Escape') {
          this._closeSearch(e);
        }
      });
    }
    _closeSearch(e) {
      this.classList.remove('active');
    }
    _searching() {
      return '<div class="header-search__no-type"><p class="search-results__loading"><span class="spinner"></span>Buscando resultados...</p></div>';
    }
    _focus(e) {
      this.classList.add('active');
    }
    _serchSuggestionList() {
      return this.suggestions;
    }
    _typing(e) {
      e.preventDefault();

      const results = this.querySelector('#search-results');

      if (e.target.value === '') {
        results.innerHTML = this._serchSuggestionList();
        return;
      }

      results.innerHTML = this._searching();

      fetch(
        window.Shopify.routes.root +
          'search/suggest?q=' +
          this.input.value +
          '&resources[limit]=10&resources[limit_scope]=each&section_id=predictive-search',
        {
          method: 'GET',
        }
      )
        .then((r) => r.text())
        .then((result) => {
          const resultHtml = new DOMParser().parseFromString(result, 'text/html');
          this.querySelector('#search-results').replaceWith(
            document.importNode(resultHtml.querySelector('#shopify-section-predictive-search'), true)
          );

          this.querySelector('.search-resilts__all-results > a').href = '/search?q=' + this.input.value;
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }
  if (!window.customElements.get('header-search')) {
    window.customElements.define('header-search', HeaderSearch);
  }

  class PredictiveSearchResults extends HTMLElement {
    constructor() {
      super();

      this.tabs = Array.from(this.querySelectorAll('.header-search__results-tab'));
      this.cards = Array.from(this.querySelectorAll('.predictive-search__result'));
      this.changeTabListener = this._changeTab.bind(this);
    }
    connectedCallback() {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.changeTabListener);
      });
    }
    _changeTab(e) {
      e.preventDefault();

      const currentTab = e.currentTarget;
      const currentType = currentTab.dataset.type;

      this.tabs = this.tabs.map((tab) => {
        tab.classList.remove('active');

        return tab;
      });
      currentTab.classList.add('active');

      this.cards = this.cards.map((card) => {
        card.style.display = card.dataset.type === currentType ? 'block' : 'none';

        return card;
      });
    }
  }
  if (!window.customElements.get('predictive-search-results')) {
    window.customElements.define('predictive-search-results', PredictiveSearchResults);
  }

  class ViewMoreChart extends HTMLElement {
    constructor() {
      super();

      this.contentSelector = this.getAttribute('data-content');
      this.toggleListener = this._toggle.bind(this);
    }
    connectedCallback() {
      this.querySelector('.view-more-chart__button').addEventListener('click', this.toggleListener);
    }
    _toggle() {
      if (this.contentSelector) {
        this.classList.toggle('active');
        document.getElementById(this.contentSelector).classList.toggle('active');

        if (document.getElementById(this.contentSelector).classList.contains('active')) {
          this.querySelector('.view-more-chart__button').innerHTML = 'Esconder';
        } else {
          this.querySelector('.view-more-chart__button').innerHTML = 'Ver';
        }
      }
    }
  }
  if (!window.customElements.get('view-more-chart')) {
    window.customElements.define('view-more-chart', ViewMoreChart);
  }
})();
